import initialState from './initialState';
import {
  sendSearchRequest,
  updatePartnerLocationsWithPrice,
  clearPriceFromPartnerLocations,
  selectLocationByPartnerId} from '../logic/api.js';
import * as toCartActions from '../components/ToCartPopup/redux/toCartPopupActions';

export function onSearchInputChange(searchQuery) {
  return {
    type: 'SEARCH:INPUT-CHANGE',
    searchQuery
  };
}

export function submitSearch(detailNum, partnerId) {
  return (dispatch, getState) => {
    dispatch({
      type: 'SEARCH:QUERY-REQUEST-SEND'
    });

    if(!partnerId) {
      partnerId = getState().toCartPopupReducer.choosePartnerToCart;
    }

    let userLocation = {latitude: 55.889007, longitude: 37.578296}; //TODO: hardcoded user location. Need take it after https.

    sendSearchRequest({detailNum, partnerId, latitude: userLocation.latitude, longitude: userLocation.longitude})
    .then((res) =>
    {
      const partnerLocations = getState().searchReducer.partnerLocations;
      if(res.locationsPrices)
      {
        const locationsWithPrices = updatePartnerLocationsWithPrice(res, partnerLocations);
        if(locationsWithPrices && locationsWithPrices.length > 0) {
          let partnerId = locationsWithPrices.filter(location => location.bestPrice)[0].partnerId;
          const newLocations = selectLocationByPartnerId(partnerId, locationsWithPrices);
          dispatch(updatePartnerLocations(newLocations));
        }
      }
      else if(res.offers){
        const newLocations = selectLocationByPartnerId(partnerId, partnerLocations);
        dispatch(updatePartnerLocations(newLocations));
      }
      else {
        const locationsWithoutPrices = clearPriceFromPartnerLocations(partnerLocations);
        dispatch(updatePartnerLocations(locationsWithoutPrices));
      }

      dispatch(onSubmitSearchSuccess(res));
    })
    .catch((err) => dispatch(onSubmitSearchFail(err)));
  };
}

const updatePartnerLocations = (locationsWithPrices) => ({
  type: 'SEARCH:UPDATE-PARTNER-LOCATIONS',
  partnerLocations: locationsWithPrices
});

const onSubmitSearchSuccess = (res) => ({
  type: 'SEARCH:QUERY-REQUEST-SUCCESS',
  foundDetail: res.foundDetail,
  foundDetailOffers: res.offers
});

const onSubmitSearchFail = (err) => ({
  type: 'SEARCH:QUERY-REQUEST-FAIL',
  err
});

export function openToCartPopup(chosenOfferId) {
  return (dispatch) => {
    dispatch({
      type: 'SEARCH:TOCART-POPUP-OPEN',
      chosenOfferId: chosenOfferId
    });

    dispatch(toCartActions.openToCartPopup());
  };
}

export function filterInStock(inStock) {
  return {
    type: 'SEARCH:FILTER-INSTOCK',
    inStock: inStock
  };
}

export function filterPriceMinValue(priceMinValue) {
  return {
    type: 'SEARCH:FILTER-PRICE-MIN-VALUE',
    priceMinValue: priceMinValue
  };
}

export function filterPriceMaxValue(priceMaxValue) {
  return {
    type: 'SEARCH:FILTER-PRICE-MAX-VALUE',
    priceMaxValue: priceMaxValue
  };
}

export function filterSupplier(supplierFilterValues) {
  return {
    type: 'SEARCH:FILTER-SUPPLIER',
    supplierFilterValues: supplierFilterValues
  };
}

export function filterBestOffers(bestOfferValue) {
  return {
    type: 'SEARCH:FILTER-BEST-OFFERS',
    bestOfferValue
  };
}

export default function searchReducer(state = initialState.searchState, action) {
  switch(action.type) {
    case 'SEARCH:QUERY-REQUEST-SUCCESS':
      return {
        ...state,
        foundDetail: action.foundDetail,
        foundDetailOffers: action.foundDetailOffers
      };


    case 'SEARCH:TOCART-POPUP-OPEN':
      return {
        ...state,
        chosenOfferId: action.chosenOfferId
      };

    case 'SEARCH:INPUT-CHANGE':
      return {
        ...state,
        searchQuery: action.searchQuery,
      };

    case 'SEARCH:CHOOSE-PARTNER-ID':
      return {
        ...state,
        partnerId: action.partnerId,
      };

    case 'SEARCH:REMOVE-PARTNER-ID':
      return {
        ...state,
        partnerId: action.partnerId,
      };

    case 'SEARCH:FILTER-INSTOCK':
      return {
        ...state,
        inStock: action.inStock
      };

    case 'SEARCH:FILTER-PRICE-MIN-VALUE':
      return {
        ...state,
        priceMinValue: action.priceMinValue
      };

    case 'SEARCH:FILTER-PRICE-MAX-VALUE':
      return {
        ...state,
        priceMaxValue: action.priceMaxValue
      };

    case 'SEARCH:UPDATE-PARTNER-LOCATIONS':
      return {
        ...state,
        partnerLocations: action.partnerLocations
      };

    case 'SEARCH:FILTER-BEST-OFFERS':
      return {
        ...state,
        bestOfferValue: action.bestOfferValue,
      };

    case 'SEARCH:FILTER-SUPPLIER':
      return {
        ...state,
        supplierFilterValues: action.supplierFilterValues
      };

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/searchActions.js
 **/